import type { WorldSnapshot } from "@frontier/protocol/contracts";
import { galaxyRegionAt } from "./galaxy-navigation";

/** Flight rendering is local to the owned sector; the galaxy chart keeps the full snapshot. */
export function flightWorld(world: WorldSnapshot, playerId: string): WorldSnapshot {
  if (!world.boundaryRules) return world;
  const regionId = world.players.find(ship => ship.id === playerId)?.sectorId;
  const belongs = (point: { x: number; y: number; sectorId?: string }) =>
    regionId !== undefined && galaxyRegionAt(world, point)?.id === regionId;
  return {
    ...world,
    players: world.players.filter(belongs),
    npcs: world.npcs.filter(belongs),
    loot: world.loot.filter(belongs),
    obstacles: world.obstacles.filter(belongs),
    gates: world.gates.filter(belongs),
    projectiles: world.projectiles.filter(belongs),
    combatEffects: world.combatEffects.filter(belongs),
    publicEvents: world.publicEvents.filter(event => event.sectorId === regionId),
    ...(world.beacons ? { beacons: world.beacons.filter(belongs) } : {}),
  };
}
